import { uniq } from 'lodash-es';
import pluralize from 'pluralize';
import * as Yup from 'yup';

/**
 *
 * @param delimitedValues whitespace delimited values
 * @returns array of undelimited strings
 */
export function extractDelimitedValues(delimitedValues: string): string[] {
  return uniq(delimitedValues.split(/\s{1,}/).filter((email) => email.length));
}

/**
 *
 * @param email
 * @returns email is valid
 */
export function isEmailValid(email: string): boolean {
  return Yup.string().email('Email valid').isValidSync(email);
}

/**
 *
 * @param delimitedEmails whitespace delimited emails
 * @returns error message describing invalid emails or null
 */
export function getInvalidEmailErrorMessage(delimitedEmails: string): string | null {
  const emails = extractDelimitedValues(delimitedEmails);
  const invalidEmails = emails.filter((email) => {
    return !isEmailValid(email);
  });
  const errorCount = invalidEmails.length;
  if (!errorCount) {
    return null;
  }
  let errorMessage = `'${invalidEmails[0]}' is not a valid email`;
  if (errorCount > 1) {
    errorMessage += `, along with ${errorCount - 1} ${pluralize('other', errorCount - 1)}`;
  }
  return `${errorMessage}.`;
}
